module.exports = new __parcel__URL__("stripe-logo.02e6bd19.png").toString();